module.exports = __webpack_public_path__ + "static/media/sidebar-2.3bf28e1e.jpg";